export default __webpack_public_path__ + "static/media/fi_archive_created.80eca509.svg";